export const CellPadding = "0.65rem";

type CreateStyleParams = {
    /**
     * Mängd (px/ch/rem/something)
     */
    amount: number;
    /**
     * Storlekstyp
     */
    unit?: string;
};

/**
 * Stödfunk för CellContentWidth för att slippa skriva om samma formel fler gånger
 */
const createStyle = ({ amount, unit = "rem" }: CreateStyleParams) => `calc(${amount}${unit} + ${CellPadding} * 2)`;

/**
 * Standardstorlekar på celler i tabellen
 */
export const CellContentWidth = {
    /**
     * Storlek för sånt som inte är content, t.ex collapse/expand-kolumnen, kolumnen med checkbox/radio button, dropdown
     */
    icon: createStyle({ amount: 1.5 }),
    tiny: createStyle({ amount: 3 }),
    xxxs: createStyle({ amount: 4.5 }),
    xxs: createStyle({ amount: 5.5 }),
    xs: createStyle({ amount: 6.5 }),
    s: createStyle({ amount: 7.5 }),
    default: createStyle({ amount: 10 }),
    m: createStyle({ amount: 12 }),
    l: createStyle({ amount: 16 }),
    xl: createStyle({ amount: 22 }),
    max: createStyle({ amount: 30 }),
    custom: (params: CreateStyleParams) => createStyle(params),
};

export enum CellContentAlignment {
    Top = "top",
    Center = "center",
    Bottom = "bottom",
}

export enum CellContentJustification {
    Left = "left",
    Center = "center",
    Right = "right",
}
